import State from "@/helpers/pattern/state";
import { Merchandising } from "@/models/operativos/merchandising";
import { modelIsModified } from "@/helpers/vue-mc";
import merchandisingAPI from "@/services/operativos/merchandising";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";
import { clearSwal } from "@/constants/sweet-alerts";
import { scrollToForm } from "@/helpers/form-scroll-to";

/**
 * State Pattern for merchandising form
 */
export default class MerchandisingStates extends State {
  /**
   * General Methods
   */
  base() {
    return {
      clear({ $setState }) {
        $setState("initial");
      }
      , async askForClear({ $data }) {
        try {
          if ((await $data.$swal(clearSwal)).value) this.clear();
        } catch (error) {
          console.error(error);
        }
      }
      , resetModel({ $data }) {
        $data.merchandising = new Merchandising();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.merchandising) || $data.view.action.submit.busy || !modelIsModified($data.merchandising);
      }
    };
  }

  /**
   * States and their methods
   */
  states() {
    return {
      initial: {
        $constructor: function ({ $data }) {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.save;
        }
        , async submit({ $data }, { descripcion, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await merchandisingAPI.save({
              clave: null
              , descripcion
              , status
            });

            $data.view.action.submit.busy = false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.merchandisingTable.refreshData();
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
      , editing: {
        $constructor: function ({ $data }, { clave, descripcion, status }) {
          // View configuration buttons
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.title.current = $data.view.elem.button.submit.title.update;

          $data.merchandising = new Merchandising({
            clave
            , descripcion
            , status
          });

          this.resetValidators();
          scrollToForm($data);
        }
        , async submit({ $data, $setState }, { clave, descripcion, status }) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy = true;

            const response = await merchandisingAPI.update({
              clave
              , descripcion
              , status
            });

            $data.$refs.merchandisingTable.refreshData();
            $data.view.action.submit.busy = false;
            $setState("initial");
            return response;
          } catch (error) {
            console.error(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/operativos/merchandising/merchandising-state.js